import { Button } from '@nazka/nazka.mapframe.components'

import './mode-selection-modal.styl'
import { useDispatch } from 'react-redux'
import { setUserSelectedMode } from '../../../library/MaplibreMap/maplibre-map.redux.actions'

function ModeSelectionModal() {
  const dispatch = useDispatch()
  
  return (
    <div className="mode-selection-modal">
      <div className="mode-selection-modal__single-card">
        <h4>Flood damage estimation</h4>
        <img src="/img/riverflood.png" alt="flood damage" />
        <p>
          Calculates and visualizes the expected flood
          damage to buildings to identify flood vulnerability hotspots in terms of flood damage.
        </p>
        <Button
          css={{
            borderRadius: '3px',
          }}
          onClick={() => dispatch(setUserSelectedMode('River flood'))}
        >
          Select
        </Button>
      </div>
      <div className="mode-selection-modal__single-card">
        <h4>Urban runoff simulation</h4>
        <img src="/img/flashflood.png" alt="flood damage" />
        <p>
          Simulates rainfall runoff to identify urban flood
          vulnerability hotspots with hydrological impacts from blue-green infrastructure (BGI).
        </p>
        <Button
          css={{
            borderRadius: '3px',
          }}
          onClick={() => dispatch(setUserSelectedMode('Flash flood'))}
        >
          Select
        </Button>
      </div>
    </div>
  )
}

export default ModeSelectionModal